export default __webpack_public_path__ + "static/media/rig-not-working-01.fc206449.png";